var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-container",style:(_vm.style),domProps:{"innerHTML":_vm._s(require(`!html-loader!../../assets/svg/${_vm.name}.svg`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }